/* eslint-disable */
import Layout from '@/layout/index.vue';

const routes = {
  // 主页
  Home: () => import(/* webpackChunkName: "dict" */ '@/views/page/Home/index')
};

export const homeRoute = [
  {
    path: '/Home',
    isMenu: true,
    component: Layout,
    redirect: { name: 'Home' },
    children: [
      {
        path: 'index',
        name: 'Home',
        component: routes['Home'],
        meta: { title: '首页', icon: 'menu_shouye'}
      }
    ]
  }
];
